import React from "react";
import { CornerUpLeft, X } from "lucide-react";

const ReplyPreviewBar = ({ replyTarget, onCancel }) => {
  if (!replyTarget) return null;

  return (
    <div className="bc-reply-preview bc-reply-preview-compact">
      <div className="bc-reply-preview-bar" />
      <CornerUpLeft size={13} className="bc-reply-preview-icon" />
      <div className="bc-reply-preview-body">
        <span className="bc-reply-preview-line">
          <span className="bc-reply-preview-author">
            Replying to {replyTarget.userName || "Unknown"}
          </span>
          <span className="bc-reply-preview-sep">·</span>
          <span className="bc-reply-preview-text">{replyTarget.preview || "Message"}</span>
        </span>
      </div>
      <button type="button" className="bc-reply-preview-close" onClick={onCancel} aria-label="Cancel reply">
        <X size={13} />
      </button>
    </div>
  );
};

export default ReplyPreviewBar;
